import { connect } from 'react-redux';
import { formsLoadExisting, formFindersLoadExisting } from '../actions';
import Dashboard from './Dashboard';

const mapStateToProps = ({ navDrawer }) => {
    return {
        activeNavItem: navDrawer.activeNavItem,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onLoad: () => {
        dispatch(formsLoadExisting());
        dispatch(formFindersLoadExisting());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
